import _ from "lodash"

const verticalAlignTypes = {
  baseline: "baseline",
  bottom: "bottom",
  top: "top",
  middle: "middle",
}

const verticalAlignValues = _.values(verticalAlignTypes)

const sortDirections = {
  asc: "asc",
  desc: "desc",
}

const sortDirectionsValues = _.values(sortDirections)

const sortableColumnIcons = {
  asc: "fa-sort-up",
  desc: "fa-sort-down",
}

export {
  verticalAlignTypes,
  verticalAlignValues,
  sortDirections,
  sortDirectionsValues,
  sortableColumnIcons,
}

export const htmlType = {
  table: "table",
  div: "div",
}
